/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Box, IconButton } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { Autocomplete } from '@mui/material';
import CreatePDF from './CreatePdf';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import PropTypes, { func } from 'prop-types'
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { useTheme } from '@mui/material/styles'
import services from '../Service';

var screenCode = "REJECTGRNDETAILSREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell></TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

export default function RejectGRNDetailReport() {
    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Reject GRN Detail Report'
    });
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('FarmerName');
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [grnDetails, setGRNDetails] = useState([]);
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [IsFarmerClear, setIsFarmerClear] = useState(false);
    const [farmer, setFarmer] = useState([]);
    const [directSupllierDetails, setDirectSupllierDetails] = useState([]);
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        farmerID: 0,
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
    });
    const [farmerDa, setFarmerata] = useState({
        supplierTypeID: 1
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        farmerID: '',
        toDate: '',
        fromDate: ''
    });
    const [totalValues, setTotalValues] = useState({
        totalAmount: 0,
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const classes = useStyles();

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            farmerID: formData.farmerID,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
        },

        validationSchema: () => {
            return Yup.object().shape({
                groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
                operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center is required'),
                toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
                fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
            });
        },

        onSubmit: () => {
            trackPromise(SubmitForm());
        }
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };
    async function SubmitForm() {
        setPage(0);
        let model = {
            groupID: parseInt(formik.values.groupID),
            operationEntityID: parseInt(formik.values.operationEntityID),
            supplierTypeID: farmerDa.supplierTypeID,
            farmerID: farmerDa.supplierTypeID == 1 ? parseInt(formik.values.farmerID || 0) : parseInt(formik.values.directSupplierID || 0),
            StartDate: new Date(fromDate).toISOString(),
            EndDate: new Date(toDate).toISOString()
        }
        let newRes = await services.GetRejectGRNDetailReportData(model);
        if (newRes.length != 0) {
            setGRNDetails(newRes);
            calculateTotalQty(newRes)
        }
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(getPermissions());
        setPage(0);
    }, []);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        trackPromise(GetFarmerDetailsByFactoryIDRouteID(), GetDirectSupplierDetails());
        setIsFarmerClear(!IsFarmerClear)
        setGRNDetails([]);
    }, [formik.values.operationEntityID]);


    useEffect(() => {
        setGRNDetails([]);
    }, [formik.values.farmerID]);

    useEffect(() => {
        setGRNDetails([]);
        setIsFarmerClear(!IsFarmerClear)
    }, [farmerDa.supplierTypeID]);

    useEffect(() => {
        setGRNDetails([]);
    }, [toDate]);

    useEffect(() => {
        setGRNDetails([]);
    }, [fromDate]);

    useEffect(() => {
        setGRNDetails([]);
        setFromDate(new Date());
        setToDate(new Date());
    }, [formik.values.farmerID, formik.values.operationEntityID]);


    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWREJECTGRNDETAILSREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }

    async function GetFarmerDetailsByFactoryIDRouteID() {
        var res = await services.GetFarmerDetailsByFactoryIDRouteID(formik.values.operationEntityID)
        if (res != null) {
            setFarmer(res);
        }
    }

    async function GetDirectSupplierDetails() {
        var res = await services.GetDirectSupplierDetails(formik.values.operationEntityID);
        if (res != null) {
            let newRes = res.filter(x => x.isActive == 1)
            setDirectSupllierDetails(newRes);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(grnDetails);
        var settings = {
            sheetName: 'Reject GRN Detail Report',
            fileName: 'Reject GRN Detail Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Reject GRN Detail Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'GRN Date': new Date(x.grnDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 }),
                    'GRN Number': x.invoiceNumber == null ? '-' : x.invoiceNumber,
                    'Supplier Code': x.farmerCode == null ? '-' : x.farmerCode,
                    'Full name': x.middleName == null ? '-' : x.middleName,
                    'Total value': x.totalAmount == null ? '-' : parseFloat(x.totalAmount).toFixed(2),
                    'Remark': x.remark == null ? '-' : x.remark
                }
                res.push(vr);
            });

            var vr = {
                'GRN Date': 'Total',
                'Total value': totalValues.totalAmount == null ? '-' : parseFloat(totalValues.totalAmount).toFixed(2)
            }
            res.push(vr);
            res.push({});
            res.push({});
        }
        return res;
    }

    async function clearAll() {
        setIsFarmerClear(!IsFarmerClear)
        setFormData({
            ...formData,
            farmerID: 0,
        })
        setGRNDetails([]);
        setFromDate(new Date());
        setToDate(new Date());
    }

    function calculateTotalQty(grnDetails) {
        const totalAmount = grnDetails.reduce((accumulator, current) => accumulator + current.totalAmount, 0);
        setTotalValues({
            ...totalValues,
            totalAmount: totalAmount,
        })

    };

    const filterOptions = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();
        const filteredOptions = options.filter(option =>
            (option.givenName && option.givenName.toLowerCase().includes(trimmedInput)) ||
            (option.nic && option.nic.toLowerCase().startsWith(trimmedInput)) ||
            (option.farmerCode && option.farmerCode.toLowerCase().startsWith(trimmedInput))
        ).filter(option => option.givenName !== null && option.nic !== null && option.farmerCode !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.givenName.toLowerCase() === trimmedInput ||
                option.nic.toLowerCase() === trimmedInput ||
                option.farmerCode.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });
        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    const filterOptionsOne = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.supplierName && option.supplierName.toLowerCase().includes(trimmedInput)) ||
            (option.nic && option.nic.toLowerCase().startsWith(trimmedInput))
        ).filter(option => option.supplierName !== null && option.nic !== null
        );

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.supplierName.toLowerCase() === trimmedInput ||
                option.nic.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });
        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    function handleSearchDropdownChangePrefferdName(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            var nameP = 'farmerID';
            var valueP = data.farmerID;
            setValues({
                ...values,
                farmerID: valueP
            });
        }
    }

    function handleSearchDropdownChangePrefferdNameOne(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...values,
                directSupplierID: '0'
            });
            return;
        } else {
            var nameP = 'directSupplierID';
            var valueP = data.directSupplierID;
            setValues({
                ...values,
                directSupplierID: valueP
            });
        }
    }

    function handleChangeType(e) {
        const target = e.target;
        const value = target.value

        setFarmerata({
            ...farmerDa,
            supplierTypeID: value
        });
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Reject GRN Detail Report   |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0} >Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Collection Center *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Fresh Collection Centers</MenuItem>
                                        {operationEntityList.map((option) => (
                                            option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        id="outlined-basic"
                                        name='supplierTypeID'
                                        variant="outlined"
                                        label="Supplier Type *"
                                        value={farmerDa.supplierTypeID}
                                        onChange={(e) => { handleChangeType(e) }}
                                    >
                                        <MenuItem value={1}> Registered Suppliers</MenuItem>
                                        <MenuItem value={2}> Direct Supplier</MenuItem>
                                    </TextField>
                                    {farmerDa.supplierTypeID == 1 ?
                                        <Autocomplete
                                            fullWidth
                                            key={IsFarmerClear}
                                            clearOnEscape
                                            id="farmerID"
                                            options={farmer}
                                            filterOptions={filterOptions}
                                            getOptionLabel={(option) => `${option.givenName} - ${option.nic}`}
                                            onChange={(e, value) => handleSearchDropdownChangePrefferdName(value, e)}
                                            renderOption={(props, option) => (
                                                <li {...props}>
                                                    {`${option.givenName} - ${option.nic}`}
                                                </li>
                                            )}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                    variant="outlined"
                                                    name="farmerID"
                                                    label="Supplier Preferred Name / NIC"
                                                    size="small"
                                                    fullWidth
                                                    helperText={touched.farmerID && errors.farmerID}
                                                    error={Boolean(touched.farmerID && errors.farmerID)}
                                                />
                                            }
                                        />
                                        :
                                        <Autocomplete
                                            fullWidth
                                            key={IsFarmerClear}
                                            clearOnEscape
                                            id="directSupplierID"
                                            options={directSupllierDetails}
                                            filterOptions={filterOptionsOne}
                                            getOptionLabel={(option) => `${option.supplierName} - ${option.nic}`}
                                            onChange={(e, value) => handleSearchDropdownChangePrefferdNameOne(value, e)}
                                            renderOption={(props, option) => (
                                                <li {...props}>
                                                    {`${option.supplierName} - ${option.nic}`}
                                                </li>
                                            )}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                    variant="outlined"
                                                    name="directSupplierID"
                                                    label="Direct Supllier Preferred Name / NIC"
                                                    size="small"
                                                    fullWidth
                                                    helperText={touched.directSupplierID && errors.directSupplierID}
                                                    error={Boolean(touched.directSupplierID && errors.directSupplierID)}
                                                />
                                            }
                                        />}
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Start Date *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select End Date"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                                {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <br />
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button type="button" variant="outlined" color="error"
                                            onClick={() => clearAll()}
                                        >
                                            Clear
                                        </Button>
                                        <Button type="submit" color="secondary" variant="outlined"
                                        >
                                            Search
                                        </Button>
                                    </Stack>
                                </Stack>
                                <br />
                                <>
                                    {grnDetails.length != 0 ? (
                                        <>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                    <Paper className={classes.paper}>
                                                        <TableContainer>
                                                            <Table
                                                                size='small'
                                                                className={classes.table}
                                                                aria-labelledby="tableTitle"
                                                                aria-label="enhanced table"
                                                            >
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell align="left">GRN Date</TableCell>
                                                                        <TableCell align="left">GRN Number</TableCell>
                                                                        <TableCell align="left">Supplier Code</TableCell>
                                                                        <TableCell align="left">Full name</TableCell>
                                                                        <TableCell align="right">Total value</TableCell>
                                                                        <TableCell align="left">Remark</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {stableSort(grnDetails, getComparator(order, orderBy))
                                                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                        .map((row, index) => {
                                                                            const labelId = `enhanced-table-checkbox-${index}`;
                                                                            return (
                                                                                <TableRow>
                                                                                    <TableCell align="left">{row.grnDate == null ? '-' : new Date(row.grnDate).toLocaleDateString()}</TableCell>
                                                                                    <TableCell align="left">{row.invoiceNumber == null ? '-' : 'R' + row.invoiceNumber}</TableCell>
                                                                                    <TableCell align="left">{row.farmerCode == null ? '-' : row.farmerCode}</TableCell>
                                                                                    <TableCell align="left">{row.middleName == null ? '-' : row.middleName}</TableCell>
                                                                                    <TableCell align="right">{row.totalAmount == null ? '-' : parseFloat(row.totalAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                                    <TableCell align="left">{row.remark == null ? '-' : row.remark}</TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        })}
                                                                </TableBody>
                                                                <TableRow>
                                                                    <TableCell align="left" colSpan={4} style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalAmount == null ? '-' : parseFloat(totalValues.totalAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell></TableCell>
                                                                </TableRow>
                                                            </Table>
                                                        </TableContainer>

                                                        <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25]}
                                                            component="div"
                                                            count={grnDetails.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onPageChange={handleChangePage}
                                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                                        />
                                                    </Paper>
                                                </Card>
                                            </Stack>
                                        </>
                                    ) : null}
                                </>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {grnDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Financial GRN Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    grnList={grnDetails}
                                    searchData={selectedSearchValues}
                                    totalValues={totalValues}
                                    fromDate={fromDate}
                                    toDate={toDate}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}